module.exports = __webpack_public_path__ + "img/lock-closed.df91dd34.svg";